import AdminNavbar from "./AdminNavBar";
import LocationNavbar from "./LocationNavBar";

const Locations = () => {
	return (
		<div className="resilire">
		<AdminNavbar />
		<LocationNavbar />
		</div>
	)
}
export default Locations;
